import React, {memo} from 'react';
import classNames from "classnames";
import PropTypes from 'prop-types';

const ShippingColumn = memo(({product, projectState}) => {
  const parse = (shipping) => {
    if (shipping === undefined || shipping === null) {
      return '-'
    }
    const formatter = new Intl.NumberFormat(projectState.locale.replace('_', '-'), {
      style: 'currency',
      currency: shipping.price.currency,
    });

    return formatter.format(shipping.price.amount / 1000)
  }
  return (
    <td className="pt-4">
      <p className={classNames({
        'text-center': true,
        'ms-4': true,
        'text-gray': !product.status
      })}>
        {parse(product.shipping)}
      </p>
    </td>
  )
});

ShippingColumn.propTypes = {
  product: PropTypes.object.isRequired,
  projectState: PropTypes.object.isRequired
};

export default ShippingColumn;
